/* eslint-disable react/jsx-sort-props */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/** Dialog de "foco" que exibe um gráfico em tamanho ampliado. */
const ChartFocusDialog = ({ open, title, action, onClose, children }) => (
  <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
    <DialogTitle
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <span>{title}</span>
      <Stack direction="row" spacing={1} alignItems="center">
        {action}
        <IconButton size="small" onClick={onClose} aria-label="Fechar">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Stack>
    </DialogTitle>
    <DialogContent sx={{ pt: 3 }}>
      <Box sx={{ width: '100%' }}>{children}</Box>
    </DialogContent>
  </Dialog>
);

ChartFocusDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  action: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
};

ChartFocusDialog.defaultProps = {
  action: null,
  children: null,
};

export default ChartFocusDialog;
